export const ROUTE_DASHBOARD = "/banking/dashboard";
export const ROUTE_CHAT = "/banking/chat";
export const ROUTE_QUIZ = "/banking/quiz";
export const ROUTE_LOGIN = "/";
export const ROUTE_SIGN_UP = "/banking/sign-up";
export const ROUTE_AI_GENERATE = "/banking/ai-generate";
export const ROUTE_DESCRIPTIVE = "/banking/descriptive";
export const ROUTE_AI_ANALYSIS = "/banking/analysis";
export const ROUTE_PROFILE = "/banking/profile";
// Admin App Routes (root level routes for admin app)
export const ROUTE_STUDENT_MANAGEMENT = "/banking/student-management";
export const ROUTE_SCHOOL_MANAGEMENT = "/banking/school-managament";
export const ROUTE_LEARNING_ASSETS = "/banking/learning-assets";
export const ROUTE_MOCK_TEST = "/banking/mock-test";
export const routeToMCQ = (subject) =>
  `/banking/${ROUTE_QUIZ}?subject=${subject}`;
export const ROUTE_COMPETITIVE_EXAM = "/banking/competitive-exam";
export const routeEvalutionToQuiz = (subject, chapter) =>
  `${ROUTE_QUIZ}?subject=${subject}&chapter=${chapter}`;
export const routeEvalutionTnspscToQuiz = (
  medium,
  part,
  unit,
  chapter,
  lesson,
) =>
  `${ROUTE_QUIZ}?medium=${medium}&part=${part}&unit=${unit}&chapter=${chapter}&lesson=${lesson}`;
